// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3L1jX","content":"styles_content__2k78c","row":"styles_row__2LyeH","footer":"styles_footer__21jSm","phraseLength":"styles_phraseLength__2sZk3"};